import $ from 'jquery';
const MODULE_NAME = 'numberValidator';
export default angular.module(MODULE_NAME, []).directive('numberValidator', function () {
	'ngInject';
	return {
		restrict: 'A',
		require: 'ngModel',
		link: function (scope, element, attrs, ngModelCtrl) {
			ngModelCtrl.$validators.format = function (modelValue) {
				var valid = false;
				if (typeof modelValue == 'undefined' || modelValue == null || modelValue === '') {
					valid = true;
				} else {
					valid = $.isNumeric(modelValue);
				}
				return valid;
			};
		}
	};
}).name;



// WEBPACK FOOTER //
// ./source/applications/kalkulator/eszkozkalkulator/validators/numbervalidator.js